import { render, staticRenderFns } from "./liveblogTimeline.vue?vue&type=template&id=72503620&scoped=true&"
import script from "./liveblogTimeline.vue?vue&type=script&lang=js&"
export * from "./liveblogTimeline.vue?vue&type=script&lang=js&"
import style0 from "./liveblogTimeline.vue?vue&type=style&index=0&id=72503620&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72503620",
  null
  
)

export default component.exports